// // const lifeStoryCategories = [
// //   {
// //     name: 'story_title_image',
// //     label: 'story_title_image',
// //     value: 0,
// //   },

// //   // {
// //   //   name: 'name_of_deceased',
// //   //   label: 'name_mayus',
// //   //   value: 1,
// //   // },
// //   // {
// //   //   name: 'birth_information',
// //   //   label: 'birth_information',
// //   //   value: 2,
// //   // },
// //   // {
// //   //   name: 'death_information',
// //   //   label: 'death_information',
// //   //   value: 3,
// //   // },

// //   // {
// //   //   name: 'known_social_media',
// //   //   label: 'known_social_media',
// //   //   value: 4,
// //   // },
// //   // {
// //   //   name: 'general_notes_section',
// //   //   label: 'general_notes_section',
// //   //   value: 5,
// //   // },
// //   // {
// //   //   name: 'funeral_details',
// //   //   label: 'funeral_details',
// //   //   value: 6,
// //   // },
// //   // {
// //   //   name: 'schools_attended',
// //   //   label: 'schools_attended',
// //   //   value: 7,
// //   // },
// //   // {
// //   //   name: 'military_service',
// //   //   label: 'military_service',
// //   //   value: 8,
// //   // },
// //   // {
// //   //   name: 'marriage',
// //   //   label: 'marriage',
// //   //   value: 9,
// //   // },

// //   // {
// //   //   name: 'family_members',
// //   //   label: 'family_members',
// //   //   value: 10,
// //   // },
// //   // {
// //   //   name: 'donate',
// //   //   label: 'donate',
// //   //   value: 11,
// //   // },
// // ];

// // const classmatesCategories = [
// //   {
// //     name: 'story_title_image',
// //     label: 'story_title_image',
// //   },
// //   // {
// //   //   name: 'class_information',
// //   //   label: 'class_information',
// //   // },
// //   // {
// //   //   name: 'class_purpose',
// //   //   label: 'class_purpose',
// //   // },
// //   // {
// //   //   name: 'class_involved',
// //   //   label: 'class_involved',
// //   // },
// // ];

// // const teammatesCategories = [
// //   {
// //     name: 'story_title_image',
// //     label: 'story_title_image',
// //   },
// //   // {
// //   //   name: 'teammates_memory',
// //   //   label: 'teammates_memory',
// //   // },
// //   // {
// //   //   name: 'teammates_names',
// //   //   label: 'teammates_names',
// //   // },
// //   // {
// //   //   name: 'general_notes',
// //   //   label: 'general_notes',
// //   // },
// // ];

// // const noneCategories = [
// //   {
// //     name: 'story_title_image',
// //     label: 'story_title_image',
// //   },
// //   // {
// //   //   name: 'name_of_event',
// //   //   label: 'name_of_event',
// //   // },
// //   // {
// //   //   name: 'location_event',
// //   //   label: 'location_event',
// //   // },
// //   // {
// //   //   name: 'people_involved',
// //   //   label: 'people_involved',
// //   // },
// //   // {
// //   //   name: 'general_notes',
// //   //   label: 'general_notes',
// //   // },
// // ];

// // const customEvent = [
// //   {
// //     name: 'story_title_image',
// //     label: 'story_title_image',
// //   },
// //   // {
// //   //   name: 'name_of_event',
// //   //   label: 'name_of_event',
// //   // },
// //   // {
// //   //   name: 'location_event',
// //   //   label: 'location_event',
// //   // },
// //   // {
// //   //   name: 'people_involved',
// //   //   label: 'people_involved',
// //   // },
// //   // {
// //   //   name: 'general_notes',
// //   //   label: 'general_notes',
// //   // },
// // ];

// const formCategories: any = {
//   life_story: lifeStoryCategories,
//   classmates_story: classmatesCategories,
//   teammates_story: teammatesCategories,
//   none_of_this_story: noneCategories,
//   custom_event: customEvent,
// };

// export { formCategories };


// storyTemplates.js
export const storyTemplates = [
  {
    title: "Life Story",
    key: "life_story",
    url: "life-story",
    content: "life_story_content",
    bgcolor: "#FFF5F2",
    header_color: '#FED9D1',
    color: "#B97B6E",
    icon: "/icons/lifeStory.svg",
    position: "center",
  },

  { title: "Custom Story", key: 'custom_story', text: 'custom_story', value: 6, url: 'custom-story', bgcolor: "#0072CE03", header_color: '#3F44C2', color: "#DCECF9", content: 'custom_story',    icon: "/images/logo-light-blue.svg",
    position: "center" },
  {
    title: "Wedding Story",
    key: "wedding_story",
    url: "wedding-story",
    content: "wedding_story_content",
    bgcolor: '#0072CE21',
    header_color: "#0072CE",
    color: "#D8E8F6",
    icon: "/icons/wedding.svg",
    position: "bottom",
  },
  {
    title: "Retirement Story",
    key: "retirement_story",
    url: "retirement-story",
    content: "retirement_story_content",
    bgcolor: '#89D3FF33',
    header_color: "#89D3FF",
    color: "#0072CE",
    icon: "/icons/retirement.svg",
    position: "bottom",
  },
  {
    title: "Classmates Story",
    key: "classmates_story",
    bgcolor: "rgba(241, 224, 255, 0.6)",
    header_color: 'rgba(241, 224, 255, 0.8)',
    color: "#8C58B8",
    icon: "/icons/classmate.svg",
    position: "bottom",
  },
  {
    title: "Teammates Story",
    key: "teammates_story",
    bgcolor: '#FFF5F2',
    header_color: "#FED9D1",
    color: "#B97B6E",
    icon: "/icons/teammate.svg",
    position: "bottom",
  },
  {
    title: "Tribute Story",
    key: "tribute_story",
    bgcolor: 'rgba(0, 114, 206, 0.13)',
    header_color: "#0072CE",
    color: "#D8E8F6",
    icon: "/icons/tribute.svg",
    position: "bottom",
  },
  {
    title: "Misc. Story",
    key: "none_of_this_story",
    bgcolor: 'rgba(0, 114, 206, 0.13)',
    header_color: "#0072CE",
    color: "#D8E8F6",
    icon: "/icons/tribute.svg",
    position: "bottom",
  },
  {
    title: "Custom Event",
    key: "custom_event",
    bgcolor: 'rgba(0, 114, 206, 0.13)',
    header_color: "#0072CE",
    color: "#D8E8F6",
    icon: "/icons/lifeStory.svg",
    position: "center",
  },


];
